module.exports = __webpack_public_path__ + "static/media/FIN.874139d4.jpg";